/**
 * These functions control loading and opening of a Mopinion feedback widget.
 * We use this because we do not want to load the Mopinion script on each page load.
 */

import initData from 'init-data';

/**
 * Returns true if Mopinion widgets is enabled.
 */
export const isEnabled = () => {
    return (
        initData &&
        initData.featureSwitches &&
        initData.featureSwitches['mopinion-feedback-widgets']
    );
};

/**
 * Adds the Mopinion script to the page.
 */
export const addScriptToDom = () => {
    if (!isEnabled()) {
        return;
    }
    const dataAttributeName = 'data-mopinion-script';
    if (document.querySelector(`[${dataAttributeName}]`)) {
        return;
    }
    const js = document.createElement('script');
    js.setAttribute(dataAttributeName, '1');
    js.setAttribute('type', 'text/javascript');
    js.setAttribute('src', '//deploy.mopinion.com/js/pastease.js');
    document.getElementsByTagName('head')[0].appendChild(js);
};

/**
 * Loads the Mopinion survey with the given ID.
 * @param {String} memberId The currently logged in member
 * @param {String} mopinionDeploymentId The ID of the Mopinion survey
 */
export const loadMopinionWidget = (memberId, mopinionDeploymentId) => {
    if (!isEnabled()) {
        return;
    }
    let attemptsLeft = 100;
    const timeBetweenAttempts = 50;
    const t = setInterval(function() {
        if (window.Pastease) {
            window.memberId = memberId;
            new window.Pastease.load(mopinionDeploymentId);
            clearInterval(t);
        } else if (--attemptsLeft < 1) {
            clearInterval(t);
        }
    }, timeBetweenAttempts);
};

/**
 * Opens the Mopinion widget that is currently loaded.
 */
export const openMopinionWidget = () => {
    if (!isEnabled()) {
        return;
    }
    let attemptsLeft = 100;
    const timeBetweenAttempts = 50;
    const t = setInterval(function() {
        const buttonElement = document.querySelector(
            '.mopinion-survey-content button'
        );
        if (buttonElement) {
            buttonElement.click();
            clearInterval(t);
        } else if (--attemptsLeft < 1) {
            clearInterval(t);
        }
    }, timeBetweenAttempts);
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/customer-feedback/mopinion-loader.js